import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { Calendar } from "primereact/calendar";

const VendorPaymentCreate = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    date: new Date(),
  });
  const [error, setError] = useState({});
  const [vendors, setVendors] = useState([]);
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      Http.get("/vendor"),
      Http.get("/accounts/banks")
    ])
      .then(([vendorsRes, banksRes]) => {
        setVendors(vendorsRes.data);
        setBanks(banksRes.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleDateChange = (e) => {
    setInputs((values) => ({ ...values, date: e.value }));
  };

  const formSubmit = () => {
    Http.post("/accounts/vendor-payments", inputs)
      .then((res) => {
        navigate("/vendor-payments", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Vendor Payment</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Payment Information</h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            <div className="row">
              <div className="col-lg">
                <label>Payment Date <span className="text-danger">*</span></label>
                <Calendar
                  value={inputs.date}
                  onChange={handleDateChange}
                  dateFormat="dd/mm/yy"
                  className="w-100"
                />
              </div>
              <div className="col-lg">
                <label>Reference No</label>
                <input
                  type="text"
                  className="form-control"
                  name="reference_no"
                  value={inputs.reference_no || ""}
                  onChange={handleChange}
                  placeholder="Enter Reference Number"
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg">
                <label>Vendor <span className="text-danger">*</span></label>
                <select
                  className="form-control"
                  name="vendor_id"
                  value={inputs.vendor_id || ""}
                  onChange={handleChange}
                >
                  <option value="">Select Vendor</option>
                  {vendors.map((vendor) => (
                    <option key={vendor.id} value={vendor.id}>
                      {vendor.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg">
                <label>Bank <span className="text-danger">*</span></label>
                <select
                  className="form-control"
                  name="bank_id"
                  value={inputs.bank_id || ""}
                  onChange={handleChange}
                >
                  <option value="">Select Bank</option>
                  {banks.map((bank) => (
                    <option key={bank.id} value={bank.id}>
                      {bank.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg">
                <label>Amount <span className="text-danger">*</span></label>
                <input
                  type="number"
                  className="form-control"
                  name="amount"
                  value={inputs.amount || ""}
                  onChange={handleChange}
                  placeholder="Enter Amount"
                />
              </div>
              <div className="col-lg">
                <label>Payment Method <span className="text-danger">*</span></label>
                <select
                  className="form-control"
                  name="payment_method"
                  value={inputs.payment_method || ""}
                  onChange={handleChange}
                >
                  <option value="">Select Payment Method</option>
                  <option value="bank_transfer">Bank Transfer</option>
                  <option value="cash">Cash</option>
                  <option value="check">Check</option>
                  <option value="online">Online Payment</option>
                </select>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg">
                <label>Description</label>
                <textarea
                  className="form-control"
                  name="description"
                  value={inputs.description || ""}
                  onChange={handleChange}
                  placeholder="Enter Description"
                  rows="3"
                ></textarea>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-3">
                <button
                  className="btn btn-primary btn-block mg-b-10"
                  onClick={formSubmit}
                >
                  <i className="fa fa-save mg-r-10"></i> Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorPaymentCreate;